module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-5.add53f36.svg";